import loginProps from "common/managers/loginProps";
/**
 * Constructor for the final interface that is returned
 * @param strings Key-value mapping for locale strings
 * @param language The language being used
 * @constructor
 */
var Locale = function(strings, language) {
    this.mapping = $.extend({}, strings);
    this.language = language;
};

/**
 * Load a resource from the locale folder.
 * @param nameOfResource
 */
Locale.prototype.getResource = function(nameOfResource) {
    return $.get({
        url: context.path + "/app/assets/nls/" + this.language + "/" + nameOfResource
    });
};

/**
 * Retrieve a locale specific string.  Supports varargs that will be replaced in the form of {n}.
 * Supports conditionally modifying the key based on the first argument.
 * @param key The key of the string
 * @param [arg0] The first value to conditionally replace
 * @returns {string} locale specific string
 */
Locale.prototype.get = function(key, arg0) {
    if (arg0 !== undefined && this.mapping.hasOwnProperty(key + ".conditional." + arg0)) {
        key = key + ".conditional." + arg0;
    }
    var val = this.mapping[key];
    for (var i = 0; i < arguments.length - 1; ++i) {
        var reg = new RegExp("\\{" + i + "\\}", "gm");
        val = val.replace(reg, arguments[i + 1]);
    }
    return val;
};

/**
 * Format a date into a locale specific version.
 *
 * This should be used in favor of kendo.toString, because it may at some point
 * extend to support timezones.
 *
 * @param {date} when A Date object
 * @param {string=} format One of the date formats as specified by kendo
 */
Locale.prototype.formatDate = function(when, format) {
    if (!format) {
        format = Locale.prototype.getDateFormat();
    }
    if (!format) {
        format = "d";
    }
    return kendo.toString(when, format);
};

/**
 * Format a date into a locale specific version that includes the time.
 *
 * This should be used in favor of kendo.toString, because it may at some point
 * extend to support timezones.
 *
 * @param {date} when A Date object
 * @param {string=} format One of the date formats as specified by kendo
 */
Locale.prototype.formatDateTime = function(when, format) {
    if (!format) {
        format = Locale.prototype.getDateTimeFormat();
    }
    if (!format) {
        format = "g";
    }
    return kendo.toString(when, format);
};

Locale.prototype.parseDate = function(value, format) {
    if (typeof value === "number") {
        return new Date(value);
    }
    if (!format) {
        format = Locale.prototype.getDateFormat();
    }
    return kendo.parseDate(value, format);
};

/**
 * Format an amount of currency using the system property
 *
 * @param amount
 */
Locale.prototype.formatCurrency = function(amount) {
    return kendo.toString(amount, "c");
};

/**
 * Returns the system date format as returned by the server.
 */
Locale.prototype.getDateFormat = function() {
    var formats = loginProps.get().dateFormats;
    return formats ? formats.date : null;
};

Locale.prototype.getDateTimeFormat = function() {
    var formats = loginProps.get().dateFormats;
    return formats ? formats.dateTime : null;
};

/**
 * Get the time formats that should be parsed in order.
 */
Locale.prototype.getTimeFormats = function() {
    return [
        "hh:mm tt",
        "hh:mmtt",
        "h:mm",
        "h:",
        "h tt",
        "htt",
        "hh",
        "h",
        "HH:mm",
        "H:mm",
        "H:",
        "HH",
        "H"
    ];
};

/**
 * Get the possible date formats.
 */
Locale.prototype.getDateFormats = function() {
    var format = loginProps.get().dateFormat || "";
    switch (format.charAt(0)) {
        case "D":
            return [
                "dd-dd-yyyy",
                "dd/MM/yyyy",
                "ddMMyyyy",
                "d-M-yyyy",
                "d/M/yyyy",
                "dd-MM-yy",
                "dd/MM/yy",
                "d-M-yy",
                "d/M/yy",
                "ddMMyy",
                "dd-MM",
                "dd/MM",
                "d-M",
                "d/M"
            ];
        case "Y":
            return [
                "yyyy-MM-dd",
                "yyyy/MM/dd",
                "yyyyMMdd",
                "yyyy-M-d",
                "yyyy/M/d",
                "yy-MM-dd",
                "yy/MM/dd",
                "yy-M-d",
                "yy/M/d",
                "yyMMdd"
            ];
        case "M":
        default:
            return [
                "MM-dd-yyyy",
                "MM/dd/yyyy",
                "MMddyyyy",
                "M-d-yyyy",
                "M/d/yyyy",
                "MM-dd-yy",
                "MM/dd/yy",
                "M-d-yy",
                "M/d/yy",
                "MMddyy",
                "MM-dd",
                "MM/dd",
                "M-d",
                "M/d"
            ];
    }
};

/**
 * Get all the possible date time formats that should be parsed.
 */
Locale.prototype.getDateTimeFormats = function() {
    var dateTime = [];
    var dateFormats = this.getDateFormats();
    var timeFormats = this.getTimeFormats();
    dateFormats.forEach(function(dateFormat) {
        timeFormats.forEach(function(timeFormat) {
            dateTime.push(dateFormat + " " + timeFormat);
        });
    });
    return [].concat(["g"], dateTime, ["d"], dateFormats, timeFormats);
};

export default Locale;
